<template lang="pug">
  v-tabs(
    fixed-tabs
    center-active)
    v-tab(
      v-for="({ route, name, icon }) in active"
      :key="route.name"
      replace
      exact
      :to="{ name: route.name }") {{ name }}
</template>

<script>
import { state } from '..'
import { toRefs } from '@vue/composition-api'

import { VTabs, VTab } from 'vuetify/lib'

export default {
  components: { VTabs, VTab },

  setup () {
    return {
      ...toRefs(state)
    }
  }
}
</script>
